module.exports = __webpack_public_path__ + "static/img/Captura de tela de 2024-11-05 15-05-15.6ec2ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Captura de tela de 2024-11-05 15-05-15.png
// module id = Eb0x
// module chunks = 4